import { createStore } from 'vuex'
import tab from './tab'

export default createStore({
  modules: {
    tab
  },
  state: {
    shudata: null
  },
  mutations: {
    chuanshudata(state, item) {
      state.shudata = item
    }
  }
})
